import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "obi fixed-height" }
const _hoisted_2 = { style: {"margin-left":"auto"} }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_dialogs = _resolveComponent("dialogs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      (_ctx.showBackLink)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/menu",
            class: "top-menu-link"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("メニュー", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(this.$route.meta.title), 1)
    ]),
    _createVNode(_TransitionGroup, { name: "tran-nortification" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalState.nortification.list, (nortice) => {
          return (_openBlock(), _createElementBlock("div", {
            key: nortice.message,
            class: _normalizeClass(['header-nortification-' + nortice.type, "header-nortification"])
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(nortice.message), 1),
            _createElementVNode("span", {
              style: {"margin-left":"auto","font-size":"x-large","padding":"0 10px","cursor":"pointer","line-height":"0"},
              onClick: ($event: any) => (_ctx.globalState.nortification.clear(nortice.identifer))
            }, " × ", 8, _hoisted_3)
          ], 2))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "main-contents",
      style: _normalizeStyle({'min-height':'calc(100vh - 120px - ' + (_ctx.globalState.nortification.list.length * 40) + 'px)'})
    }, [
      _createVNode(_component_router_view)
    ], 4),
    _createElementVNode("div", {
      class: "back-link-wrap fixed-height",
      style: _normalizeStyle({'visibility': _ctx.showBackLink ? 'visible':'hidden'})
    }, [
      _createVNode(_component_router_link, { to: "/menu" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("メニューに戻る", -1)
        ]))]),
        _: 1
      })
    ], 4),
    _cache[2] || (_cache[2] = _createElementVNode("header", {
      class: "obi fixed-height",
      style: {"text-align":"right"}
    }, " all right reserved. ", -1)),
    _createVNode(_component_dialogs, { ref: "dialogs" }, null, 512)
  ], 64))
}